import script from "./ManageSurveysBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageSurveysBox.vue?vue&type=script&setup=true&lang=js"

import "./ManageSurveysBox.vue?vue&type=style&index=0&id=b4ffdfbc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4ffdfbc"]])

export default __exports__